export const LocationsDropdownController = (
  $scope,
  locationsGenericService
) => {
  $scope.openLocationDropDown = event => {
    event.stopPropagation()
  }

  $scope.selectAllLocations = () => {
    locationsGenericService.selectOrDeselectAllLocations(
      $scope.regionsList,
      true
    )
    updateLocationDropdown()
  }

  $scope.deselectAllLocations = () => {
    locationsGenericService.selectOrDeselectAllLocations(
      $scope.regionsList,
      false
    )

    updateLocationDropdown()
  }

  $scope.selectLocation = (selectedValue, event) => {
    locationsGenericService.selectLocation(
      $scope.regionsList,
      selectedValue,
      event
    )
    updateLocationDropdown()
  }

  const updateLocationDropdown = () => {
    const selectedLocation = locationsGenericService.setIsSelectedChildrenLocation(
      $scope.regionsList,
      []
    )
    $scope.onLocationChange({selectedLocation: selectedLocation})
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/locations/locations-dropdown.ctrl.js